export enum LinkTitle {
  Home = 'Home',
  NewClient = 'New client',
  CreateNewClient = 'Create new client',
  BulkEditClients = 'Bulk edit clients',
  MeetingCenter = 'Meeting center',
  RecurringTasks = 'Recurring tasks',
  ClientPlanning = 'Client planning',
  FilingCenter = 'Filing center',
  ProcessScheduler = 'Process scheduler',
  EnterTargetDates = 'Enter target dates',
  EnterPreviousPeriods = 'Enter previous periods',
  TaskAssignment = 'Task assignment',
  ProjectAssignments = 'Project assignments',
  TaxPaymentCenter = 'Tax payment center',
  BillingCenter = 'Billing center',
  NewInvoice = 'New invoice',
  NewPayment = 'New payment',
  NewCharge = 'New charge',
  PaymentTask = 'Payment task',
  EnterPreviousPeriod = 'Enter previous period',
  RecurringItems = 'Recurring items',
  SalesCenter = 'Sales center',
  GeneralJournal = 'General journal',
  TemplateCenter = 'Template center',
  CreateNewTemplate = 'Create new template',
  ManageLists = 'Manage lists',
  WorkLogCenter = 'Work log center',
  NoteCenter = 'Note center',
  CallLogs = 'Call logs',
  ProjectAuditTrail = 'Project audit trail',
  CreditAuditTrail = 'Credit audit trail',
  ChartOfAccounts = 'Chart of accounts',
  PayCommission = 'Pay commission',
  StaffCenter = 'Staff center',
  Settings = 'Settings',
  WebPages = 'Web pages',
  RolesAndUsers = 'Roles & users',
  TaskGenerationLog = 'Task generation log',
  Task = 'Task',
  Reminder = 'Reminder',
  Message = 'Message',
  Future = 'Future',
  Charge = 'Charge',
  Payment = 'Payment',
  EditClient = 'Edit client',
  EditTask = 'Edit task',
  Client = 'Client',
  EditClientTab = 'Edit',
  EditTemplate = 'Edit template',
  SignIn = 'Sign in',
}
